import type { User } from "../types/user"

export const mockUsers: User[] = [
  {
    id: "1",
    name: "Dr. Maria Silva",
    email: "maria.silva@universidade.edu.br",
    role: "researcher",
    institution: "Universidade Federal do Brasil",
    status: "active",
    createdAt: "2024-01-15",
    lastLogin: "2024-01-22",
    projectsCount: 3,
    collectionsCount: 15,
  },
  {
    id: "2",
    name: "Prof. João Santos",
    email: "joao.santos@instituto.gov.br",
    role: "professor",
    institution: "Instituto de Pesquisas Biológicas",
    status: "active",
    createdAt: "2024-01-10",
    lastLogin: "2024-01-21",
    projectsCount: 2,
    collectionsCount: 8,
  },
  {
    id: "3",
    name: "Ana Costa",
    email: "ana.costa@estudante.edu.br",
    role: "student",
    institution: "Universidade Estadual",
    status: "active",
    createdAt: "2024-01-20",
    lastLogin: "2024-01-22",
    projectsCount: 1,
    collectionsCount: 5,
  },
  {
    id: "4",
    name: "Carlos Oliveira",
    email: "carlos.oliveira@lab.com",
    role: "technician",
    institution: "Laboratório de Análises",
    status: "inactive",
    createdAt: "2024-01-05",
    lastLogin: "2024-01-18",
    projectsCount: 0,
    collectionsCount: 0,
  },
  {
    id: "5",
    name: "Dra. Fernanda Lima",
    email: "fernanda.lima@pesquisa.org",
    role: "admin",
    institution: "Centro de Pesquisas Ambientais",
    status: "active",
    createdAt: "2024-01-01",
    lastLogin: "2024-01-22",
    projectsCount: 5,
    collectionsCount: 25,
  },
]
